"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchCallStatus = void 0;
exports.BatchCallStatus = {
    Pending: "pending",
    InProgress: "in_progress",
    Completed: "completed",
    Failed: "failed",
    Cancelled: "cancelled",
};
